import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import {Button} from "reactstrap";
import UniversalModalOverride from "components/UniversalModalOverride";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Users',
		url: '/users',
		icon: 'users',
	},
];


class Users extends Framework.Components.View {
	handleAddUsers=()=>{
		//TODO: need to see if need to unsubscribe rootstate on unmount
		this.props.rootState.triggerAction('getUserInformation', null);
		this.handleAfterSave();
	}
	render() {
		let { locations, states, reloadShell, userCount } = this.props.rootState;
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					<div style={{margin: '0 6px', display: 'inline-block'}}><i>{userCount} User Subscriptions</i></div>
					<Button data-id="add-user" onClick={this.toggle('modalUser')} size="sm" color="primary">
						<i className="fa fa-user"/>&nbsp;&nbsp;Add User
					</Button>
				</Framework.Components.PageBar>

				<Collections.Users
					history={this.props.history}
					locations={locations}
					states={states}
					reloadShell={reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>

				<UniversalModalOverride
					locations={locations}
					states={states}
					name="User"
					object={Objects.User}
					history={this.props.history}
					toggle={this.state['modalUser']}
					reportClose={this.reportClose('modalUser')}
					afterSave={this.handleAddUsers}
				/>

			</div>
		);
	}
}

export default Framework.Components.withRootState(Users);